import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import routes from './routes.js';
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.use(VueRouter);


const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

window.componentRefs = {};

window.vm = new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
